import React, { useState } from "react";
import {
  PasswordInput,
  RadioInput,
  TextInput,
} from "../components/common/ui/Inputs";
import { Link } from "react-router-dom";
import { decryptData, encryptData } from "../utils/encryptDecrypt";
import loginSchema from "../validation/loginSchema";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../_store";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import { history } from "../_helpers";
import Button from "../components/common/ui/Button";
import forgotPasswordSchema from "../validation/forgotPasswordSchema";
import { Popup } from "../components/common/ui/NotificationModal/Popup";
import { use } from "react";

function UserLogin() {
  const dispatch = useDispatch();
  const [isActiveForm, setIsActiveForm] = useState("login");
  const [email, setEmail] = useState("");
  const [userLoginForm, setUserLoginForm] = useState({
    email: "",
    password: "",
    authendication: "email",
    isAdminPanel: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForgotPassword, setIsLoadingForgotPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [qr, setQr] = useState("");
  const [twoFactorOTP, setTwoFactorOTP] = useState("");
  const [showAlert, setShowAlert] = useState(true);

  const { authendication } = useSelector((x) => x?.dropDown);

  const handleChange = (e) => {
    debugger;
    const { name, value } = e?.target;
    if (name === "email") {
      const regex = /^[a-zA-Z0-9.@!#$*+-_\s]*$/;
      if (!regex.test(value)) return;
      if (value.trim() === "" && value !== "") return;
      // setUserLoginForm({ ...userLoginForm, [name]: value.trim() });
    }

    setUserLoginForm({
      ...userLoginForm,
      [name]: value.trim(),
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const submitUserLoginForm = (e) => {
    debugger;
    e?.preventDefault();
    setIsLoading(true);
    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = loginSchema(userLoginForm);
    if (error?.details) {
      setIsLoading(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [e?.path.toString()]: e?.message,
        }));
        document
          .querySelector(`input[name=${path}]`)
          .classList.add("input-error");
      });
      return;
    }
    // showToastNotification("info", "Button clicked");
    const encryptPassword = encryptData(userLoginForm?.password);
    const safeEncrypted = encodeURIComponent(encryptPassword);
    dispatch(
      authActions.login({
        email: userLoginForm?.email,
        // password: userLoginForm?.password,
        isAdminPanel: false,
        authendication: userLoginForm?.authendication,
        password: safeEncrypted,
      })
    )
      .then((result) => {
        setIsLoading(false);
        if (result?.payload?.status === 1) {
          // const isTwoFactorEnabled = result?.payload?.data?.isTwoFactorEnabled;
          // if (userLoginForm?.authendication === "mfa" && !isTwoFactorEnabled) {
          //   setIsActiveForm("2FA");
          //   setQr(result?.payload?.qrCode);
          // }
          // history?.navigate("/home");
          history?.navigate("/login/OTP", {
            state: {
              email: userLoginForm?.email,
              from: "email",
            },
          });
          showToastNotification(result?.payload?.message, "success");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setIsLoading(false);
      });
  };

  const submitForgotPasswordForm = (e) => {
    e.preventDefault();
    setErrorMessage({});
    setIsLoadingForgotPassword(true);
    const { error } = forgotPasswordSchema({ email });
    if (error?.details) {
      setIsLoadingForgotPassword(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    dispatch(authActions?.forgotPassword({ email: email }))
      .then((result) => {
        setIsLoadingForgotPassword(false);
        if (result?.payload?.status === 1) {
          Popup({
            title: "Message",
            text: `${result?.payload?.message}`,
            icon: "success",
            confirmButtonText: "Ok",
            onConfirm: () => {
              setIsActiveForm("login");
            },
          });

          handleReset();
          dispatch(authActions.clearForgotPasswordResponse());
        } else {
          showToastNotification(result?.error?.message, "error");
          Popup({
            title: "Message",
            text: `${result?.error?.message}`,
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((err) => {
        Popup({
          title: "Message",
          text: `Failed to create committee`,
          icon: "error",
          confirmButtonText: "OK",
        });
        setIsLoadingForgotPassword(false);
      });
  };

  const handleForgotPasswordEmail = (e) => {
    const { name, value } = e?.target;
    if (name === "email") {
      // const regex = /^[a-zA-Z0-9.@_\s]*$/;
      const regex = /^[a-zA-Z0-9.@!#$*+-_\s]*$/;
      if (!regex.test(value)) return;
      if (value.trim() === "" && value !== "") return;
    }
    setEmail(e?.target?.value);
  };

  const handleReset = () => {
    setEmail("");
  };

  const handleOTPForLogin = (e) => {
    const { value } = e?.target;
    setTwoFactorOTP(value);
  };

  const submitOTPForLogin = (e) => {
    debugger;
    e?.preventDefault();
    dispatch(
      authActions.verifyTwoFactor({
        email: userLoginForm?.email,
        token: twoFactorOTP,
      })
    )
      .then((result) => {
        debugger;
        setIsLoading(false);
        if (result?.payload?.status === 1) {
          debugger;
          history?.navigate("/login/OTP");
        } else {
          debugger;
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        debugger;
        showToastNotification(err?.message, "error");
        setIsLoading(false);
      });
  };

  return (
    <>
      {/* {showAlert && (
      <div id="ie-alert" class="ie-alert">
        <button
          class="ie-alert-close"
          onClick={() => setShowAlert(false)}
        >
          &times;
        </button>
        <span class="ie-alert-icon">&#9888;</span> 
        For the best experience, use <strong>Chrome</strong>, <strong>Edge</strong>, or <strong>Safari</strong> to access the site.
      </div>
      )} */}

      <section className="sign-in-section">
        <div className="container">
          <div className="row g-0 login-container">
            <div className="col-md-6 right-panel d-flex align-items-center">
              <span className="sr-only" role="img" alt="BPK Login Page" aria-label="BPK Login Page"></span>
              <div className="right-panel-content w-100">
                <h6 className="mb-2">WELCOME TO</h6>
                <h2 className="fw-bold mb-3 text-nowrap">
                  BROWARD PARTNERSHIPS FOR KIDS
                </h2>
                <p className="px-3 text-white">
                  {/* The BPK Committee Stands As A Dedicated Force Committed To The
                Overall Growth And Development Of Children. */}
                  {/* Together with our community, we open doors of opportunity, care,
                and support for Broward’s children and families */}
                  Together, we open doors of opportunity, care, and support for
                  Broward’s children and families
                </p>
              </div>
            </div>
            <div className="col-md-6 sign-in">
              <div className="login-form">
                {isActiveForm === "login" || isActiveForm === "2FA" ? (
                  <h2 className="mb-4">Login Into Your Account</h2>
                ) : (
                  <h2 className="mb-4 text-left">Forgot Password</h2>
                )}
                {isActiveForm === "login" ? (
                  <form
                    onSubmit={(e) => {
                      submitUserLoginForm(e);
                    }}
                  >
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label">
                        Email<span className="text-danger">*</span>
                      </label>

                      <TextInput
                        name="email"
                        id="email"
                        placeholder="Email Address"
                        ariaLabel="Email Address"
                        required={true}
                        handleChange={(e) => {
                          handleChange(e);
                        }}
                        value={userLoginForm?.email}
                        errorMessage={errorMessage}
                      />
                    </div>
                    <div className="mb-4">
                      <label htmlFor="password" className="form-label">
                        Password<span className="text-danger">*</span>
                      </label>
                      <PasswordInput
                        name="password"
                        ariaLabel="Password"
                        id="password"
                        placeholder="Password"
                        required={true}
                        handleChange={(e) => {
                          handleChange(e);
                        }}
                        value={userLoginForm?.password}
                        showPassword={showPassword}
                        togglePasswordVisibility={togglePasswordVisibility}
                        maxlength={25}
                        errorMessage={errorMessage}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-0">
                      <div className="form-check"></div>
                      <Link
                        onClick={() => {
                          setIsActiveForm("forgotPassword");
                          setErrorMessage({});
                          document
                            .querySelectorAll(".input-error")
                            .forEach((el) => el.classList.remove("input-error"));
                        }}
                        aria-label="Forgot password recovery"
                        className="text-decoration-none text-primary"
                      >
                        Forgot Password
                      </Link>
                    </div>
                    <div className="div-center">
                      <button
                        type="submit"
                        className="sign-in-button"
                        disabled={isLoading}
                      >
                        Login
                        {!isLoading ? (
                          <i className="css-arrow-icon bi bi-arrow-right"></i>
                        ) : (
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                      </button>
                    </div>

                    <div className="text-center mt-4">
                      Don't Have An Account?{" "}
                      <Link
                        to="/register"
                        className="text-primary text-decoration-none"
                        aria-label="Register a new account"
                      >
                        Register
                      </Link>
                    </div>
                  </form>
                ) : isActiveForm === "2FA" ? (
                  <form
                    onSubmit={(e) => {
                      submitOTPForLogin(e);
                    }}
                  >
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      {qr && <img src={qr} alt="QR Code" />}

                      <TextInput
                        name="twoFactorOTP"
                        id="twoFactorOTP"
                        ariaLabel="Enter One-Time code"
                        placeholder="Enter One-Time code"
                        handleChange={(e) => {
                          handleOTPForLogin(e);
                        }}
                        value={twoFactorOTP}
                      />

                      <button
                        type="submit"
                        className="sign-in-button"
                        disabled={isLoading}
                      >
                        Verify One-Time Code
                        {!isLoading ? (
                          <i className="css-arrow-icon bi bi-arrow-right"></i>
                        ) : (
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        )}
                      </button>
                    </div>
                  </form>
                ) : (
                  <form
                    onSubmit={(e) => {
                      submitForgotPasswordForm(e);
                    }}
                  >
                    <p className="font-size-16">
                      Enter the email you used to sign up for your BPK account.
                      We'll send you a link to reset your password.
                    </p>
                    <div className="mb-4">
                      <label htmlFor="forgot-password-email" className="form-label">
                        Email<span className="text-danger">*</span>
                      </label>

                      <TextInput
                        name="email"
                        id="forgot-password-email"
                        value={email}
                        handleChange={(e) => {
                          handleForgotPasswordEmail(e);
                        }}
                        ariaLabel="Email Address"
                        placeholder="Email Address"
                        required={true}
                        errorMessage={errorMessage}
                      //    handleBlur={handleBlur}    // temporarly Commented
                      />
                    </div>

                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {/* <Button status="green" type="submit" label="Submit" /> */}
                      <div className="div-center">
                        <button
                          type="submit"
                          className="sign-in-button"
                          disabled={isLoadingForgotPassword}
                        >
                          Submit
                          {!isLoadingForgotPassword ? (
                            <i className="css-arrow-icon bi bi-arrow-right"></i>
                          ) : (
                            <div className="spinner-border" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          )}
                        </button>
                      </div>
                      {/* <Button
                      status="reset"
                      label="Reset"
                      type="reset"
                      onClick={handleReset}
                      disabled={true}
                    /> */}
                    </div>

                    <div className="text-left mt-4">
                      Back to Login?{" "}
                      <Link
                        role="button"
                        tabIndex={0}
                        aria-label="Back to login"
                        onClick={() => {
                          setIsActiveForm("login");
                          setErrorMessage({});
                          document
                            .querySelectorAll(".input-error")
                            .forEach((el) => el.classList.remove("input-error"));
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setIsActiveForm("login");
                            setErrorMessage({});
                            document
                              .querySelectorAll(".input-error")
                              .forEach((el) => el.classList.remove("input-error"));
                          }
                        }}
                        className="text-primary text-decoration-none"
                      >
                        Login
                      </Link>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default UserLogin;
